var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#F3F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4477 10.8664C21.9493 10.6031 21.4333 10.3498 20.9114 10.1097C18.8504 10.7767 16.4339 11.655 13.9979 12.7459C13.7637 12.8494 13.563 13.0163 13.4185 13.2277C13.2741 13.4391 13.1915 13.6867 13.1802 13.9425C13.1421 15.1181 13.1304 16.3315 13.1459 17.5312C13.1471 17.5664 13.137 17.6011 13.1171 17.6301C13.0972 17.6591 13.0685 17.681 13.0353 17.6926C13.002 17.7041 12.9659 17.7046 12.9323 17.6941C12.8987 17.6836 12.8693 17.6627 12.8485 17.6342C12.5912 17.3042 12.3393 16.978 12.0931 16.6554C12.0749 16.6302 12.0479 16.6127 12.0175 16.6065C11.9871 16.6002 11.9554 16.6056 11.9288 16.6217C11.7376 16.7349 11.5498 16.8469 11.3654 16.9576C11.2621 17.0195 11.1349 16.9369 11.1343 16.8098C11.1281 15.6147 11.1581 14.4165 11.2219 13.2551C11.2488 12.7653 11.556 12.3041 12.0108 12.0795C14.3468 10.9267 16.8394 9.98409 18.9664 9.28645C18.4714 9.09279 17.9792 8.91521 17.4987 8.74691C16.8509 8.52447 16.1474 8.52447 15.4996 8.74691C13.8964 9.29976 12.1457 10.0218 10.5508 10.8664C9.58158 11.3747 9.00399 12.4034 8.97831 13.428C8.91478 15.4761 8.91478 17.5241 8.97831 19.5721C9.00306 20.5968 9.58158 21.6254 10.5508 22.1337C12.1457 22.9783 13.8964 23.7004 15.5008 24.2532C16.1486 24.4757 16.8521 24.4757 17.5 24.2532C19.1031 23.7007 20.8539 22.9783 22.4499 22.1337C23.4186 21.6254 23.9968 20.5968 24.0221 19.5721C24.0855 17.5241 24.0855 15.4761 24.0221 13.428C23.9955 12.4034 23.4167 11.3747 22.4477 10.8664Z",
    fill: "#A6ADB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadNotification);
export default __webpack_public_path__ + "static/media/read-notification.88abe296bf2296f0de344cb274f099e2.svg";
export { ForwardRef as ReactComponent };